<script>
/**
 * 之所以不用css，因为在某些屏幕时，会出现显示的问题
 * https://github.com/inouetakuya/vue-nl2br
 * 
 */
export default {
  name: 'sby-nl2br',
  functional: true,
  props: {
    tag: {
      type: String,
      default: 'span'
    },
    text: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      required: false
    }
  },
  render(createElement, context) {
    return createElement(context.props.tag, {
      'class': context.props.className
    }, context.props.text.split('\n').reduce((accumulator, string) => {
      if (!Array.isArray(accumulator)) {
        return [accumulator, createElement('br'), string]
      }
      return accumulator.concat([createElement('br'), string])
    }))
  },
}
</script>



// WEBPACK FOOTER //
// src/components/sby-nl2br.vue